import { BlankFillingQuestion, Question } from '@entities/lesson'
import { QuestionFunnelStepKey } from '@features/lesson-review/model'
import { match } from 'ts-pattern'

/**
 * 퍼널 스텝 키 생성 함수
 */
export const createFunnelStepKey = (index: number) => `REVIEW_${index}` satisfies QuestionFunnelStepKey

/**
 * 다음 퍼널 스텝 키 생성 함수
 */
export const createNextFunnelStepKey = (index: number) => `REVIEW_${index + 1}` satisfies QuestionFunnelStepKey

/**
 * 마지막 스텝인지 확인하는 함수
 */
export const isLastStep = (currentIndex: number, totalSteps: number) => currentIndex === totalSteps - 1

export const shouldBlockDeferredNpsForUpcomingLesson = (
  startUnixSec: number | null | undefined,
  nowUnixSec: number,
  guardSec = 600,
  endUnixSec?: number | null,
) => {
  if (startUnixSec === null || startUnixSec === undefined || !Number.isFinite(startUnixSec)) {
    return false
  }

  const secondsUntilLessonStart = startUnixSec - nowUnixSec

  if (secondsUntilLessonStart >= 0) {
    return secondsUntilLessonStart <= guardSec
  }

  if (endUnixSec === null || endUnixSec === undefined || !Number.isFinite(endUnixSec)) {
    return true
  }

  return nowUnixSec <= endUnixSec
}

export const replaceSentenceByAnswer = (blankFillingQuestion: BlankFillingQuestion, answer: string[]) => {
  const answerLength = blankFillingQuestion.source.answer.length

  const answerStartIndex = blankFillingQuestion.source.body.findIndex((_, index, body) => {
    return body.slice(index, index + answerLength).join(' ') === blankFillingQuestion.source.answer.join(' ')
  })

  const result = [
    ...blankFillingQuestion.source.body.slice(0, answerStartIndex),
    ...answer,
    ...blankFillingQuestion.source.body.slice(answerStartIndex + answerLength),
  ]

  return result
}

export const getMasterAnswerByQuestion = (question: Question) => {
  return match(question)
    .returnType<string>()
    .with({ type: 'BLANK_FILLING' }, (blankFillingQuestion) => blankFillingQuestion.source.answer.join(' '))
    .with({ type: 'MULTI_CHOICE_SENTENCE' }, (multiChoiceSentenceQuestion) =>
      multiChoiceSentenceQuestion.source.answer.toString(),
    )
    .with({ type: 'MULTI_CHOICE_WORD' }, (multiChoiceWordQuestion) => multiChoiceWordQuestion.source.answer.toString())
    .with({ type: 'SENTENCE_MAKING' }, (sentenceMakingQuestion) => sentenceMakingQuestion.source.answer)
    .otherwise(() => '')
}
